import React from 'react';
import RevisionNumber from 'utils/components/RevisionNumber/RevisionNumber';
import 'utils/components/RevisionNumber/RevisionNumber.scss';
import RevisionLabel from '../RevisionLabel';
import { NavigationProps } from '../Navigation';
import './NumberNavigation.scss';

type NumberNavigationProps = Pick<
    NavigationProps,
    'listIndex' | 'endIndex' | 'dispatchSetListIndexAction'
>;
export default function NumberNavigation(props: NumberNavigationProps) {
    const { listIndex, endIndex, dispatchSetListIndexAction } = props;

    const pageCount = endIndex + 1;
    const navNumbers = Array.from(new Array(pageCount)).map((v, i) => (
        <RevisionNumber
            key={i}
            valIndex={i}
            listIndex={listIndex}
            setIndex={dispatchSetListIndexAction}
        />
    ));

    return (
        <div className="NumberNavigation">
            <RevisionLabel endIndex={endIndex} />
            {navNumbers}
        </div>
    );
}
